module.exports = "/images/zink-automated-finance-software.png?35c1428206b8c1a085cc8532f188747b";